import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PRODUCTS } from "../../lib/routes";
import { FiArrowRight, FiShield, FiTruck, FiZap } from "react-icons/fi"; // Added icons for value props
import { useAddToWarpList } from "../../hooks/emails/useAddToWarpList";

const categories = [
  {
    title: "Toys & Figures",
    param: "toys-figures",
    img: "https://firebasestorage.googleapis.com/v0/b/loot-layer.firebasestorage.app/o/products%2F3b592e8a-ba10-4430-b5e0-7bc541fea712-zoro.jpg?alt=media&token=dbbf5247-da37-4456-921d-e7bbeeafb896",
    featured: true,
    description: "Premium statues and articulated figures from your favorite series."
  },
  {
    title: "Trading Cards",
    param: "trading-cards",
    img: "https://firebasestorage.googleapis.com/v0/b/loot-layer.firebasestorage.app/o/cards.jpg?alt=media&token=c1f79855-98ba-4a4a-87bb-ddf2912c9507",
    description: "Booster packs, slabs, and rare singles."
  },
  {
    title: "Accessories",
    param: "accessories",
    img: "https://firebasestorage.googleapis.com/v0/b/loot-layer.firebasestorage.app/o/products%2FOrz7uwOUJbokhAezzpJH%2Fc960327e-a3a1-47db-a121-22f3fa0574c1-minecraft-keychain2.jpg?alt=media&token=5414fc25-d99c-45bc-acb4-12f29b21164f",
    description: "Keychains, apparel, and collection protection."
  },
];

const Home = () => {
  const featuredCategory = categories.find(cat => cat.featured);
  const otherCategories = categories.filter(cat => !cat.featured);
  const [email, setEmail] = useState("");
  const { addToWarpList, isLoading } = useAddToWarpList();

  const handleSubscribe = async () => {
    const success = await addToWarpList(email);
    if (success) {
      setEmail(""); // Clear the input on success
    }
  };

  return (
    <div className="bg-[#fafafa] min-h-screen flex flex-col items-center overflow-x-hidden">
      
      {/* Hero Section */}
      <section className="relative w-full bg-slate-900 text-white py-32 px-6 flex flex-col items-center justify-center text-center">
        {/* Background Decorative Blobs */}
        <div className="absolute top-0 left-1/4 w-72 h-72 bg-purple-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
        <div className="absolute bottom-0 right-1/4 w-72 h-72 bg-indigo-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>

        <div className="relative z-10 max-w-4xl">
          <span className="inline-block py-1 px-3 rounded-full bg-purple-500/20 text-purple-300 text-sm font-bold mb-6 tracking-widest uppercase">
            New Arrivals Just Dropped
          </span>
          <h1 className="text-5xl sm:text-7xl font-black mb-8 tracking-tighter leading-tight">
            Loot<span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-indigo-400">Layer</span>
          </h1>
          <p className="text-lg sm:text-xl mb-10 text-gray-300 max-w-2xl mx-auto leading-relaxed italic">
            "Rare collectibles, exclusive figures, and fan-favorite treasures curated for the ultimate collector."
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to={PRODUCTS}
              className="bg-purple-600 text-white px-10 py-4 rounded-2xl font-bold shadow-xl shadow-purple-500/20 hover:bg-purple-500 hover:-translate-y-1 active:scale-95 transition-all flex items-center justify-center"
            >
              Start Shopping <FiZap className="ml-2" />
            </Link>
          </div>
        </div>
      </section>

      {/* Trust Badges Accessory */}
      <section className="w-full max-w-7xl px-6 -mt-10 z-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 bg-white p-8 rounded-3xl shadow-xl border border-gray-100">
          
          {/* Delivery */}
          <div className="flex items-center space-x-4 px-4">
            <div className="p-3 bg-purple-100 rounded-2xl text-purple-600">
              <FiTruck size={24}/>
            </div>
            <div>
              <h4 className="font-bold text-gray-900 text-lg">Secure Shipping</h4>
              <p className="text-sm text-gray-500">Carefully packed for collectors</p>
            </div>
          </div>

          {/* Authenticity - SAFE VERSION */}
          <div className="flex items-center space-x-4 px-4 border-y md:border-y-0 md:border-x border-gray-100 py-4 md:py-0">
            <div className="p-3 bg-indigo-100 rounded-2xl text-indigo-600">
              <FiShield size={24}/>
            </div>
            <div>
              <h4 className="font-bold text-gray-900 text-lg">Curated Quality</h4>
              <p className="text-sm text-gray-500">Hand-selected by our team</p>
            </div>
          </div>

          {/* Speed/Exclusivity */}
          <div className="flex items-center space-x-4 px-4">
            <div className="p-3 bg-green-100 rounded-2xl text-green-600">
              <FiZap size={24}/>
            </div>
            <div>
              <h4 className="font-bold text-gray-900 text-lg">Authentic Loot</h4>
              <p className="text-sm text-gray-500">Genuine items from official sources</p>
            </div>
          </div>

        </div>
      </section>

      {/* Featured Category */}
      <section className="w-full max-w-7xl px-6 mt-24 mb-12">
        <div className="flex justify-between items-end mb-8">
          <div>
            <h2 className="text-4xl font-black text-gray-900 mb-2">Editor's Pick</h2>
            <p className="text-gray-500 font-medium">This week's most wanted collection</p>
          </div>
        </div>

        {featuredCategory && (
          <Link
            to={`${PRODUCTS}?category=${featuredCategory.param}`}
            className="relative block group overflow-hidden rounded-[2.5rem] shadow-2xl transition-all duration-500"
          >
            <div className="aspect-[21/9] sm:aspect-[21/7]">
              <img
                src={featuredCategory.img}
                alt={featuredCategory.title}
                className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-1000"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-transparent flex flex-col justify-center p-8 sm:p-16">
              <h3 className="text-4xl sm:text-6xl font-black text-white mb-4 drop-shadow-lg">
                {featuredCategory.title}
              </h3>
              <p className="text-gray-200 max-w-md mb-8 text-lg font-medium hidden sm:block">
                {featuredCategory.description}
              </p>
              <div>
                <span className="inline-flex items-center bg-white text-gray-900 px-8 py-3 rounded-full font-bold group-hover:bg-purple-600 group-hover:text-white transition-colors duration-300">
                  Shop Collection <FiArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
                </span>
              </div>
            </div>
          </Link>
        )}
      </section>

      {/* Subcategories Grid */}
      <section className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-7xl w-full px-6 mb-28">
        {otherCategories.map((cat, idx) => (
          <Link
            key={idx}
            to={`${PRODUCTS}?category=${cat.param}`}
            className="relative overflow-hidden rounded-[2rem] group shadow-lg hover:shadow-2xl transition-all duration-500 bg-white"
          >
            <div className="flex flex-col sm:flex-row h-full">
              <div className="w-full sm:w-1/2 aspect-square overflow-hidden">
                <img
                  src={cat.img}
                  alt={cat.title}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                />
              </div>
              <div className="w-full sm:w-1/2 p-8 flex flex-col justify-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-2 group-hover:text-purple-600 transition-colors">
                  {cat.title}
                </h3>
                <p className="text-gray-500 text-sm mb-6">
                  {cat.description}
                </p>
                <span className="text-purple-600 font-bold flex items-center text-sm uppercase tracking-wider">
                  Browse items <FiArrowRight className="ml-2 group-hover:translate-x-2 transition-transform" />
                </span>
              </div>
            </div>
          </Link>
        ))}
      </section>

      {/* Newsletter / CTA */}
      <section className="w-full max-w-5xl mx-6 mb-24 p-12 rounded-[3rem] bg-gradient-to-br from-purple-700 to-indigo-900 text-center text-white relative overflow-hidden">
        <div className="relative z-10">
          <h2 className="text-3xl sm:text-4xl font-black mb-4">Don't Miss the Next Drop</h2>
          <p className="text-purple-200 mb-8 max-w-md mx-auto">Get notified about restocks and exclusive limited editions before everyone else.</p>
          <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <input 
              type="email" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email" 
              disabled={isLoading}
              className="flex-1 px-6 py-4 rounded-2xl bg-white/10 border border-white/20 text-white placeholder:text-white/50 focus:outline-none focus:ring-2 focus:ring-white/50 disabled:opacity-50"
            />
            <button 
              onClick={handleSubscribe}
              disabled={isLoading}
              className="bg-white text-purple-700 font-bold px-8 py-4 rounded-2xl hover:bg-purple-50 transition-colors disabled:cursor-not-allowed"
            >
              {isLoading ? "Joining..." : "Join Warp List"}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;